module.exports = "//public.zight.com/packs/media/images/collection-71566f75b30929c841a6e536cad399ae.svg";